import React from 'react';
import clsx from 'clsx';
import { SerializedPublicAccountTrackerType } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { TrackerMark } from './TrackerMark';
import { chipTypeFor, supportedTrackerTypes, trackerProviderMark } from './trackerProviders';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './SMLTrackers.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SupportedTrackerChipsProps {
  /** The provider the pasted snippet turned out to be. Its chip lights up. */
  hitType?: SerializedPublicAccountTrackerType;
}

/** The three providers the page promises, named where they are needed. */
const SupportedTrackerChipsComponent: React.FC<SupportedTrackerChipsProps> = ({ hitType }) => {
  const hitChip = hitType === undefined ? undefined : chipTypeFor(hitType);

  return (
    <div className={styles.chips}>
      {supportedTrackerTypes.map((type) => {
        const mark = trackerProviderMark(type);
        if (mark === undefined) {
          return null;
        }
        return (
          <span key={type} className={clsx(styles.chip, hitChip === type && styles.chipHit)}>
            <TrackerMark mark={mark} size="chip" />
            {mark.name}
          </span>
        );
      })}
    </div>
  );
};

export const SupportedTrackerChips = TypedMemo(SupportedTrackerChipsComponent);
